import { createRequestTypes } from 'utils/redux';

export const GET_ALL_NEWS = createRequestTypes('GET_ALL_NEWS');
